<template>
  <section id="intro">
    <v-container class="text-center center-align mt-8">
      <h1 class="display-3 greend--text hidden-xs-only">
        Kräutertee aus Gnadenthal
      </h1>
      <h1 class="text-center display-1 greend--text hidden-sm-and-up">
        Kräutertee aus Gnadenthal
      </h1>

      <v-responsive
        class="mx-auto title font-weight-light my-8"
        max-width="85%"
      >
        Unser Bioland-Kräutertee wird in Hünfelden-Gnadenthal angebaut, geerntet
        und schonend getrocknet.
      </v-responsive>

      <v-responsive class="mx-auto my-12" width="300">
        <v-divider></v-divider>
      </v-responsive>

      <!-- <v-row align="center" class="mb-8">
        <v-spacer></v-spacer>
        <v-col
          cols="2"
          md="1"
          class="pa-0 mx-4"
          v-for="link in linkItems"
          :key="link.name"
        >
          <v-img
            contain
            class="logo ma-auto"
            :src="link.src"
            :height="link.height"
            @click="linkClicked(link)"
          ></v-img>
        </v-col>
        <v-spacer></v-spacer>
      </v-row> -->
    </v-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      linkItems: [
        {
          name: "Bioland",
          src: require("../../assets/Bioland_Logo_2012.svg"),
          target: "https://www.bioland.de",
          height: 60
        },
        {
          name: "Organic",
          src: require("../../assets/Organic-Logo.svg"),
          target:
            "https://www.bmel.de/DE/themen/landwirtschaft/oekologischer-landbau/eu-bio-logo.html",
          height: 60
        },
        {
          name: "Oekoplant",
          src: require("../../assets/Oekoplant.png"),
          target: "https://www.oekoplant-ev.de/",
          height: 20
        }
      ]
    };
  },
  methods: {
    linkClicked(link) {
      window.open(link.target, "_blank");
    }
  }
};
</script>

<style scoped>
.logo {
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
  transition: all 0.2s ease-in-out;
}
.logo:hover {
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  cursor: pointer;
  transform: scale(1.05);
}
</style>
